import {
	FETCH_RETAILER_CHILD,
	FETCH_METRICS_DATA,
	SHOW_ALERT
} from "../action-types";
import { DEFAULT_ERROR_MESSAGE } from "../config";
import { BASE_URL } from "../../../config";
import ApiService from "../api-service";

const state = {};

const actions = {
	[FETCH_RETAILER_CHILD.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/getRetailerChild";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if ("response" in data) {
					return data;
				} else if ("errMsg" in data) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	},
	[FETCH_METRICS_DATA.action]: ({ rootState, dispatch }, payload) => {
		const endpoint = BASE_URL + "/jeet11-retail/v1.0.0/getUserMetrics";
		const requestPayload = {
			access_token: rootState.auth.ACCESS_TOKEN,
			params: {
				...payload
			}
		};
		let errMsg = DEFAULT_ERROR_MESSAGE;
		return ApiService.post(endpoint, requestPayload)
			.then(data => {
				if ("response" in data) {
					return data;
				} else if ("errMsg" in data) {
					errMsg = data.errMsg;
				}
				throw new Error(errMsg);
			})
			.catch(err => {
				console.error(err);
				const finalMsg = err.message || DEFAULT_ERROR_MESSAGE;
				dispatch(
					SHOW_ALERT.dispatch,
					{ text: finalMsg },
					{ root: true }
				);
			});
	}
};

export default {
	namespaced: true,
	state,
	actions
};
